import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field-crop-advisor', () => {
  void import('./internal/field-crop-advisor').then(({ default: Component }) => Component());
});
